// Copyright (c) Ping. All rights reserved.
import type { PaneSection } from '@features/onboarding/tour/paneGuideTypes';

export const preferencesSections: PaneSection[] = [
  {
    section: 'settings-preferences-intro',
    title: 'Preferences',
    body: 'This is where you adjust how the app behaves from day to day. Flip any setting on this pane and it takes effect right away.',
  },
  {
    section: 'settings-preferences-enter-to-send',
    title: 'Press Enter to send',
    body: 'Choose whether pressing Enter sends your message. When it is on, you can still use Shift and Enter together to start a new line.',
  },
  {
    section: 'settings-preferences-auto-download',
    title: 'Auto-download on cellular',
    body: 'Decide whether attachments download while you are on mobile data. Turn it off to save data and let them wait until you are on Wi-Fi.',
  },
];
